
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.577 15.149l13.13 13.145a.999.999 0 11-1.414 1.413l-11.718-11.73-11.73 11.717a1 1 0 01-1.414-1.415l13.146-13.13z","fill":"#1D1D1B"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"chevron-thin-mask0_3297:28490","maskUnits":"userSpaceOnUse","x":"9","y":"15","width":"27","height":"15"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.577 15.149l13.13 13.145a.999.999 0 11-1.414 1.413l-11.718-11.73-11.73 11.717a1 1 0 01-1.414-1.415l13.146-13.13z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#chevron-thin-mask0_3297:28490)"}},[_c('rect',{attrs:{"x":"45","y":"45","transform":"rotate(-180 45 45)","fill":"#000"}})])])
          )
        }
      }
    